"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function bezierToPath(bezierPaths) {
    const builder = [];
    const round = (n) => n.toLocaleString('en-us', {
        maximumFractionDigits: 3,
    });
    if (bezierPaths.length > 0) {
        const head = bezierPaths[0];
        builder.push(`M${round(head.start.x)},${round(head.start.y)}`);
        bezierPaths.forEach(path => {
            builder.push(` C${round(path.firstControl.x)},${round(path.firstControl.y)} ${round(path.secondControl.x)},${round(path.secondControl.y)} ${round(path.end.x)},${round(path.end.y)}`);
        });
    }
    return builder.join('');
}
exports.default = bezierToPath;
//# sourceMappingURL=bezierToPath.js.map